<template>
    <v-card style="border-radius:4px;"> 
        <v-toolbar flat height="45px">  
            <b>De Minimis Threshold Summary</b>
            <v-spacer></v-spacer>  
            <v-btn icon @click.native="closeDialog()" >
                <v-icon >close</v-icon>
            </v-btn>                      
        </v-toolbar>
        <v-data-table
            :headers="headers"
            :items="data"
            :loading="loading"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="paginationSync"
        >
            <template v-slot:items="props">
                <tr>
                    <td>{{ props.item.fiscalYear }}</td>
                    <td>{{ props.item.deminimisName }}</td>
                    <td class="text-xs-right">
                        {{ numFormat.formatNumber(props.item.annualAmount) }}
                    </td>
                    <td class="text-xs-right">
                        {{ numFormat.formatNumber(props.item.annualThreshold) }}
                    </td>
                    <td class="text-xs-right">
                        <span v-if="props.item.annualExcess" class="warning--text">{{ numFormat.formatNumber(props.item.annualExcess) }}</span>
                        <span v-else class="green--text">{{ numFormat.formatNumber(props.item.annualExcess) }}</span>
                    </td>
                </tr>
            </template>
        </v-data-table>
    </v-card>
</template>
<script>

import userPrefs from '@/helpers/user-prefs'
import rowsPerPageItems from '@/constants/rows-per-page'
import numFormat from '@/common/num_format'

export default {
    data () {
        const routeName = `${this.$route.name}-threshold-summary`
        const savedSort = userPrefs.getSort(routeName)
        
        return {
            numFormat,
            rowsPerPageItems,
            error: false,
            errorMessage: null,
            loading: false,
            disabled: false,
            search: null,
            paginationSync: {
                rowsPerPage: userPrefs.getRowsPerPage(routeName),
                sortBy: savedSort.sortBy,
                descending: savedSort.descending,
            },
            headers: [
                {text: 'Year',align:'left',value:'fiscalYear',width: '5%', sortable:true},
                {text: 'Type',align: 'left',value: '',width: '15%', sortable:false},
                {text: 'Annual Amount',align: 'right',value: '',width: '5%', sortable:false},
                {text: 'Annual Threshold',align: 'right',value: '',width: '5%', sortable:false},
                {text: 'Annual Excess',align: 'right',value: '',width: '5%', sortable:false},
            ],
            time_reports: []
        }   
    },
    props: ['data'],
    methods: {
        closeDialog() {
            this.$emit('update:dialogThresholdSummary', false)
        },
    },
    created() {},
    watch: {
        'paginationSync.rowsPerPage'(newVal) {
            userPrefs.updateRowsPerPage(`${this.$route.name}-threshold-summary`, newVal);
        },
        'paginationSync.sortBy'(newVal) {
            userPrefs.updateSort(`${this.$route.name}-threshold-summary`, newVal, this.paginationSync.descending)
        },
        'paginationSync.descending'(newVal) {
            userPrefs.updateSort(`${this.$route.name}-threshold-summary`, this.paginationSync.sortBy, newVal)
        }
    },
    computed: {}
}
</script>